export default "__VITE_ASSET__03aa02e2__"